import { Mail02Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { useTranslation } from 'react-i18next';

import SliderMotion from 'components/Motion/SliderMotion';

export const CandidatePortalFooter = ({ candidateId }) => {
  const { t } = useTranslation();
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL;

  return (
    <SliderMotion
      key={`footer-${candidateId || 'default'}`}
      duration={0.5}
      className="container px-4"
      delay={0.55}>
      <footer
        className="flex sm:flex-row flex-col items-center justify-between gap-2 p-8 bg-white/50 rounded-3xl shadow-sm border border-border-primary shadow-soft"
        role="contentinfo"
        aria-label={t('candidatePortal.supportSection')}>
        <div className="flex flex-col sm:items-start items-center gap-2">
          <h2 className="text-2xl font-semibold text-text-primary m-0">
            {t('candidatePortal.needHelpWithYourBackgroundCheck')}
          </h2>
          <p className="text-xl text-text-secondary font-regular text-center sm:text-left m-0">
            {t('candidatePortal.contactOurSupportTeamForAssistanceWithAnyQuestions')}
          </p>
        </div>
        <a
          href={`mailto:${supportEmail}`}
          className="text-xl text-text-secondary cursor-pointer font-regular bg-white border border-border-primary hover:border-text-text-secondary rounded-full px-8 py-4 flex items-center gap-2 hover:bg-grey-2 transition-colors duration-200 hover:text-text-secondary white no-underline hover:no-underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-text-primary"
          aria-label={t('candidatePortal.contactSupportViaEmail', { email: supportEmail })}
          aria-describedby="support-description">
          <HugeiconsIcon icon={Mail02Icon} size="16" strokeWidth={1.5} aria-hidden="true" />
          <span>{t('candidatePortal.contactSupport')}</span>
        </a>
        <span id="support-description" className="sr-only">
          {t('candidatePortal.contactSupportDescription', { email: supportEmail })}
        </span>
      </footer>
    </SliderMotion>
  );
};
